import React, { useEffect, useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { useAuth } from '../components/auth/AuthProvider';
import { useNavigate } from 'react-router-dom';
export const SettingsPage = () => {
  const [scrolled, setScrolled] = useState(false);
  const {
    isAuthenticated,
    user
  } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);
  // Redirect if not authenticated or not a seller
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-6193">
      <Navbar scrolled={scrolled} data-id="element-6194" />
      <main className="pt-24 pb-20" data-id="element-6195">
        <div className="container mx-auto px-4 md:px-6" data-id="element-6196">
          <div className="max-w-6xl mx-auto" data-id="element-6197">
            <div className="mb-8" data-id="element-6198">
              <h1 className="text-3xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-6199">
                Account Settings
              </h1>
              <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-6200">
                Manage your account preferences and profile information
              </p>
            </div>
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm" data-id="element-6201">
              <h2 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-6202">
                This is a placeholder Settings page
              </h2>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-4" data-id="element-6203">
                Current user: {user?.name || 'Not logged in'}
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-4" data-id="element-6204">
                Role: {user?.activeRole || 'None'}
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-6205">
                This page will be implemented with full settings functionality
                in a future update.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-6206" />
    </div>;
};